import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface ICardHeaderProps extends TestingProps {
  children?: React.ReactNode;
  muted?: boolean;
  className?: string;
  autoMargin?: boolean;
}

export const CardHeader: React.FunctionComponent<ICardHeaderProps> = (
  props
) => {
  return (
    <div
      className={C(
        'card-header',
        props.autoMargin && 'mr-auto',
        props.className
      )}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  );
};
